import type { PropsWithChildren } from "react";
import { RouterProvider } from "react-aria-components";
import { useHref, useNavigate } from "react-router-dom";

const ABSOLUTE_HREF_PATTERN = /^(?:[a-z][a-z\d+\-.]*:|\/\/)/i;

const useReactAriaHref = (href: string): string => {
  const routedHref = useHref(href);

  return ABSOLUTE_HREF_PATTERN.test(href) ? href : routedHref;
};

export const ReactAriaRouterProvider = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  return (
    <RouterProvider navigate={navigate} useHref={useReactAriaHref}>
      {children}
    </RouterProvider>
  );
};
